import React from 'react';
import { MockServiceGroup } from '../../../../../store/mockServiceGroups/mockServiceGroupTypes';
import SslConfiguration, { AssetAssignmentBundle, SSlConfigMode } from '../../MockServices/SslConfiguration';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import MixpanelService from '../../../../../utils/mixpanelService';
import { UPDATE_SSL_CONFIGURATION_FOR_GROUP } from '../../../../../utils/mixpanelEvents';

interface GroupParametersProps {
  group: MockServiceGroup;
  onChange: (group: MockServiceGroup) => void;
  disabled: boolean;
}

const GroupParameters = (props: GroupParametersProps) => {
  const onSSlConfigChanged = (assetBundle: AssetAssignmentBundle) => {
    //There are only two configurations possible for the group
    if (_.size(assetBundle.assets) === 0) {
      MixpanelService.track(UPDATE_SSL_CONFIGURATION_FOR_GROUP('No Ssl'));
    } else {
      MixpanelService.track(UPDATE_SSL_CONFIGURATION_FOR_GROUP('One Way SSL'));
    }
    const update = _.cloneDeep(props.group);
    update.assets = assetBundle.assets;
    props.onChange(update);
  };

  const getAssetBundle = (): AssetAssignmentBundle => {
    return {
      assets: props.group.assets ? _.cloneDeep(props.group.assets) : [],
      configKeyAssets: [], //Not Used
    };
  };

  return (
    <div className={'p-4'}>
      <Row>
        <Col md={6}>
          <SslConfiguration
            heading={<h4 className={'mb-4'}>SSL Authentication</h4>}
            assetsBundle={getAssetBundle()}
            disabled={props.disabled}
            configMode={SSlConfigMode.SERVER}
            onAssignmentChanged={onSSlConfigChanged}
            allowConfigurationProperty={false}
            disableTwoWaySSL={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default GroupParameters;
